// The procedure behind the gate a screen enforces (rule 37). Says nothing when no effective document governs the gate,
// when document control is off, or when the read failed: a missing link here claims nothing, and the gate still works.
import { Link } from 'react-router-dom';
import { useResource } from '../shells/OfficeShell';

export function ProcedureLink({ gate }: { gate: string }) {
  const res = useResource<{ documents: Array<{ id: number; docId: string; title: string }> }>(`/documents/governing?gate=${gate}`);
  const docs = res.data?.documents ?? [];
  if (!docs.length) return null;
  return (
    <p className="m-0 text-(length:--fs-sm) text-(--muted)">
      Procedure:{' '}
      {docs.map((d, i) => (
        <span key={d.id}>
          {i ? ', ' : ''}
          <Link to={`/office/documents/${d.id}`} className="underline">
            {d.docId} {d.title}
          </Link>
        </span>
      ))}
    </p>
  );
}
